export default function StyledInput({label, name, placeholder}) {
    return (
        <label className="block">
            <span className="block mb-2">{label}</span>
            <input className="px-5 py-3 w-full border border-gray-300" type="text" name={name} placeholder={placeholder}/>
        </label>
    )
}